// extracted by mini-css-extract-plugin
module.exports = {"containerChild":"Swiper_containerChild__tCHIy"};